<template>
    <div>
        <img class="text-left" :src="carImage">
        <h3 class="text-center">{{data.variant}}</h3>
        <hr>
        <div class="row" style="min-height:250px">
            <div class="col-sm-6 col-xs-12">
                <table>
                    <tbody>
                        <tr>
                            <td>QR Code</td>
                            <td>:</td>
                            <td>{{data.qrcode}}</td>
                        </tr>
                        <tr>
                            <td>Frame Number</td>
                            <td>:</td>
                            <td>{{data.frame_no}}</td>
                        </tr>
                        <tr>
                            <td>Engine Number</td>
                            <td>:</td>
                            <td>{{data.engine_no}}</td>
                        </tr>
                        <tr>
                            <td>RRN</td>
                            <td>:</td>
                            <td>{{data.rrn}}</td>
                        </tr>
                        <tr>
                            <td>Nomor Polisi</td>
                            <td>:</td>
                            <td>{{data.no_pol}}</td>
                        </tr>
                        <tr>
                            <td>Vehicle Type</td>
                            <td>:</td>
                            <td>{{data.type}}</td>
                        </tr>
                        <tr>
                            <td>Vehicle Variant</td>
                            <td>:</td>
                            <td>{{data.variant}}</td>
                        </tr>
                        <tr>
                            <td>Color</td>
                            <td>:</td>
                            <td v-if="data.color_code != '-'">{{data.color_code}} ({{data.color_description}})</td>
                            <td v-else>-</td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>
            <div class="col-sm-6 col-xs-12">
                <table>
                    <tbody>
                        <tr>
                            <td>Status</td>
                            <td>:</td>
                            <td >{{data.status}}</td>
                        </tr>
                        <tr>
                            <td>Original Location</td>
                            <td>:</td>
                            <td>{{data.ori_loc_code}}</td>
                        </tr>
                        <tr>
                            <td>Current Location</td>
                            <td>:</td>
                            <td>{{data.current_loc_code}}</td>
                        </tr>
                        <tr>
                            <td>Manufacture Year</td>
                            <td>:</td>
                            <td>{{data.manufacture_year}}</td>
                        </tr>
                        <tr>
                            <td>Owner Name</td>
                            <td>:</td>
                            <td>{{data.owner_name}}</td>
                        </tr>
                        <tr>
                            <td>Sold Date</td>
                            <td>:</td>
                            <td>{{data.sold_date}}</td>
                        </tr>
                        <tr>
                            <td>Last Scan Date</td>
                            <td>:</td>
                            <td>{{data.last_scan_date}}</td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import vehicleImage from '@/plugins/vehicleImage/vehicleImage.js'

export default {
    props : ['data'],
    data(){
        return { 
            carImage : null,
            loadDone : false
        }
    },
    mounted(){
        // console.log(vehicleImage)
        if(this.data.type != null)
            this.carImage = vehicleImage.searchImageForCar(this.data.type)
        else
            this.carImage = vehicleImage. searchImageForCarByVariant(this.data.variant)
       
        var keys = Object.keys(this.data);

        for(var i = 0; i < keys.length ; i++){
            if(!this.data[keys[i]])
                this.data[keys[i]] = "-";
        }
        console.log(this.carImage)
    }
}
</script>

<style scoped>
    table{
        border-spacing: 2px;
        width : 100%;
        margin-bottom: 16px;
        display: table;
        height : 100%;
    }
    tr{
        margin : 5px 0px;
    }
</style>